"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryTradeCashflowApi = exports.queryPositionCashflowApi = exports.queryFuturesTPSLConfig = exports.querySymbolFuturesTradeInfo = exports.futuresMarginTransfer = exports.updateMarginType = exports.queryMarginType = exports.queryTrialBalance = exports.setPositionModeApi = exports.queryFutureFeeRate = exports.registerManualAccount = exports.queryLeverageConfigure = exports.querySymbolLeverages = exports.queryFutureBalance = exports.queryHistoryPositions = exports.queryPositions = exports.queryHistoryOrders = exports.queryActiveOrders = exports.setFuturesLeverage = exports.queryCustomOrder = exports.deleteCustomOrder = exports.modifyCustomOrder = exports.batchCreateOrder = exports.postTwapOrderApi = exports.postCustomOrder = exports.getFutureMarketIndexes = exports.getFutureHistoryRates = exports.getFutureMarkets = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const utils_1 = require("./utils");
/**
 *
 * @returns 获取合约交易市场信息
 */
const getFutureMarkets = () => {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost;
    const url = host + "/future_markets/";
    return trade_utils_lib_1.Network.get({ url });
};
exports.getFutureMarkets = getFutureMarkets;
/**获取历史资金费率 */
const getFutureHistoryRates = (params) => {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().futureApiHostV2;
    const url = host + "/market/funding_rates";
    return trade_utils_lib_1.Network.get({ url, data: params });
};
exports.getFutureHistoryRates = getFutureHistoryRates;
/**
 * 获取指数价格集合
 * @param symbols 数组交易对标识符
 * @returns 指数价格集合的Observable
 */
const getFutureMarketIndexes = (symbols) => {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().futureApiHostV2;
    const url = host + "/market/indexes";
    // FIX: 当且仅当symbols非空时，传入symbol参数
    return trade_utils_lib_1.Network.get({ url, data: symbols.length ? { symbol: symbols.join(",") } : undefined });
};
exports.getFutureMarketIndexes = getFutureMarketIndexes;
/** 开单 */
const postCustomOrder = (request) => {
    return (0, utils_1.requestWithSignV2)({
        accountType: request.accountType,
        api: "/order",
        method: "POST",
        data: request,
    });
};
exports.postCustomOrder = postCustomOrder;
/** 分时委托下单 */
const postTwapOrderApi = (data) => {
    return trade_utils_lib_1.Network.post({
        url: `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().futureApiHostV2}/smart_trigger/futures_twap/`,
        data,
        authType: trade_utils_lib_1.AuthType.AccessAndTrader,
        signature: true,
    });
};
exports.postTwapOrderApi = postTwapOrderApi;
/**批量下单 */
const batchCreateOrder = (accountType, request) => {
    return (0, utils_1.requestWithSignV2)({
        accountType,
        api: "/batch_order",
        method: "POST",
        data: request,
    });
};
exports.batchCreateOrder = batchCreateOrder;
const modifyCustomOrder = (request) => {
    return (0, utils_1.requestWithSignV2)({
        accountType: request.accountType,
        api: "/reset_order",
        method: "POST",
        data: request,
    });
};
exports.modifyCustomOrder = modifyCustomOrder;
/** 关单 */
const deleteCustomOrder = (request) => {
    return (0, utils_1.requestWithSignV2)({
        accountType: request.accountType,
        api: "/order/" + request.order_id,
        method: "DELETE",
        query: {
            symbol: request.symbol,
        },
    });
};
exports.deleteCustomOrder = deleteCustomOrder;
/** 查询订单 */
const queryCustomOrder = (request) => {
    return (0, utils_1.requestWithSignV2)({
        accountType: request.accountType,
        api: "/order/" + request.order_id,
        method: "GET",
        query: {
            symbol: request.symbol,
        },
    });
};
exports.queryCustomOrder = queryCustomOrder;
/**设置合约的杠杆倍数 */
function setFuturesLeverage(data) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/leverage",
        method: "POST",
        data: data,
    });
}
exports.setFuturesLeverage = setFuturesLeverage;
/**查询活跃订单 */
function queryActiveOrders(params) {
    const { accountType } = params, query = __rest(params, ["accountType"]);
    return (0, utils_1.requestWithSignV2)({
        accountType: accountType,
        api: "/trade/active_orders",
        method: "GET",
        query: query,
    });
}
exports.queryActiveOrders = queryActiveOrders;
/**查询历史订单 */
function queryHistoryOrders(params) {
    const { accountType } = params, otherParams = __rest(params, ["accountType"]);
    const query = otherParams.filter ? otherParams : Object.assign(Object.assign({}, otherParams), { filter: "TRIGGER_REJECT" });
    return (0, utils_1.requestWithSignV2)({
        accountType: accountType,
        api: "/trade/history_orders",
        method: "GET",
        query: query,
    });
}
exports.queryHistoryOrders = queryHistoryOrders;
/**查询当前仓位 */
function queryPositions(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/positions",
        method: "GET",
        query: params,
    });
}
exports.queryPositions = queryPositions;
/**查询历史仓位 */
function queryHistoryPositions(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/history_positions",
        method: "GET",
        query: params,
    });
}
exports.queryHistoryPositions = queryHistoryPositions;
/**查询当前balance 以及 仓位 */
function queryFutureBalance(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: params.accountType,
        api: "/trade/account_detail",
        method: "GET",
    });
}
exports.queryFutureBalance = queryFutureBalance;
/**
 * @deprecated 查询币对对应的杠杆倍数 use querySymbolFuturesTradeInfo instead
 */
function querySymbolLeverages(symbol) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/leverage",
        method: "GET",
        query: symbol ? { symbol } : undefined,
    });
}
exports.querySymbolLeverages = querySymbolLeverages;
/** 查询杠杆阶梯配置 */
function queryLeverageConfigure(symbol) {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().publicApiHost;
    const url = host + "/risk_table/";
    return trade_utils_lib_1.Network.get({ url, data: symbol ? { symbol: symbol } : undefined });
}
exports.queryLeverageConfigure = queryLeverageConfigure;
/** 注册交易员账户 */
function registerManualAccount() {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().manageApiHost;
    const url = host + "/api_key/";
    return trade_utils_lib_1.Network.post({ url, data: { market: "trader" }, authType: trade_utils_lib_1.AuthType.AccessAndSpot });
}
exports.registerManualAccount = registerManualAccount;
/** 查询手续费率 */
function queryFutureFeeRate(base, quote) {
    const url = `${(0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().TRADE_HOST}/order/user_fee`;
    return trade_utils_lib_1.Network.get({
        url: url,
        data: { pair: `${base}_${quote}` },
        authType: trade_utils_lib_1.AuthType.Access,
    });
}
exports.queryFutureFeeRate = queryFutureFeeRate;
function setPositionModeApi(mode) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/position_mode",
        method: "POST",
        data: { position_mode: mode },
    });
}
exports.setPositionModeApi = setPositionModeApi;
function queryTrialBalance() {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/balance_detail",
        method: "GET",
    });
}
exports.queryTrialBalance = queryTrialBalance;
/**查询币对的保证金模式 */
function queryMarginType(symbol) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/isolate_mode",
        method: "GET",
        query: {
            symbol,
        },
    });
}
exports.queryMarginType = queryMarginType;
/**设置币对的保证金模式 */
function updateMarginType(symbol, mode) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/isolate_mode",
        method: "POST",
        data: {
            symbol,
            isolated_mode: mode,
        },
    });
}
exports.updateMarginType = updateMarginType;
/**保证金划转 */
function futuresMarginTransfer(data) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/isolate_margin",
        method: "POST",
        data,
    });
}
exports.futuresMarginTransfer = futuresMarginTransfer;
/**根据币对查询合约交易相关的信息：目前包含币对的杠杆，以及币对的全仓逐仓模式 */
function querySymbolFuturesTradeInfo(accountType, symbol) {
    return (0, utils_1.requestWithSignV2)({
        accountType: accountType,
        api: "/trade/symbol_mode",
        method: "GET",
        query: { symbol },
    });
}
exports.querySymbolFuturesTradeInfo = querySymbolFuturesTradeInfo;
/** 获取合约止盈止损的配置 */
function queryFuturesTPSLConfig() {
    const host = (0, trade_utils_lib_1.getTradeDependencyInstance)().getRunTimeHost().CONFIG_HOST;
    const url = `${host}/futures/tpsl_config.json`;
    return trade_utils_lib_1.Network.getCDN(url);
}
exports.queryFuturesTPSLConfig = queryFuturesTPSLConfig;
/**获取仓位资金流水 */
function queryPositionCashflowApi(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/position_cashflow",
        method: "GET",
        query: params,
    });
}
exports.queryPositionCashflowApi = queryPositionCashflowApi;
/**获取仓位资金流水 */
function queryTradeCashflowApi(params) {
    return (0, utils_1.requestWithSignV2)({
        accountType: trade_utils_lib_1.AccountTradeType.trader,
        api: "/trade/cashflow",
        method: "GET",
        query: params,
    });
}
exports.queryTradeCashflowApi = queryTradeCashflowApi;
